import React from 'react';
import { motion } from 'framer-motion';
import BookingDemo from '../components/BookingDemo';
import SEO from '../components/SEO';

const BookingDemoPage: React.FC = () => {
  return (
    <>
      {/* Component-based SEO for Booking Demo Page */}
      <SEO url="https://logicloud.mx/book-demo" type="website" />
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5 }}
      >
        <div className="min-h-screen bg-gray-50 py-12">
          <BookingDemo />
        </div>
      </motion.div>
    </>
  );
};

export default BookingDemoPage;
